import { SelectionParam } from '@/feature/betslip-sbk/types';
import { toSelectionParam } from '@/feature/betslip-sbk/utils/to-selection-param';

import { ResolveSelectionsResponse } from './resolve-selections';

export const mapResolveResponseToSelectionParams = ({
    events,
    selections,
}: ResolveSelectionsResponse): SelectionParam[] => {
    const eventsById = new Map(events.map(event => [event.id, event]));
    return selections.flatMap(({ event_id: eventId, market, option }) => {
        const event = eventsById.get(eventId);
        return event ? [toSelectionParam(option, market, event)] : [];
    });
};

// suspended options stay importable: they land locked and re-enable if the suspension lifts
export const partitionImportableSelections = (params: SelectionParam[]) => {
    const importable: SelectionParam[] = [];
    const dropped: SelectionParam[] = [];
    params.forEach(param => {
        const isDead = !param.market.published || param.event.status === 'FINISHED';
        (isDead ? dropped : importable).push(param);
    });
    return { importable, dropped };
};
